import styled from 'styled-components';

export const RowContainer = styled.div`
  display: grid;
  grid-gap: 3rem;
  grid-auto-flow: column;
  grid-auto-columns: 200px;
  overflow-x: scroll;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  @media screen and (max-width: 800px) {
    grid-template-columns: 10px;
    margin-left: -4rem;
    margin-right: -1.5rem;
    &:before,
    &:after {
      content: '';
      width: 1px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const RowTitle = styled.h3`
  font-size: 2.4rem;
  text-transform: capitalize;
`;

export const Header = styled.div`
  display: flex;
  justify-content: ${({ hasTitle }) =>
    hasTitle ? 'space-between' : 'flex-end'};
  align-items: center;
  margin-top: ${({ hasTitle }) => (hasTitle ? '0' : '-4rem')};
  margin-bottom: 2rem;
`;

export const ButtonContainer = styled.div`
  height: 26px;
  margin-right: -1rem;
  button {
    border: none;
    background: none;
    font-size: 3rem;
    outline: none;
    cursor: pointer;
    &:last-child {
      margin-left: 1rem;
    }
    svg {
      pointer-events: none;
    }
    &[disabled] {
      pointer-events: none;
      color: var(--l-grey);
    }
    @media (hover: hover) {
      &:hover {
        color: var(--accent);
      }
    }
  }
`;
